const en = {
    'language': 'English',

    '账号': 'Account',
    '密码': 'Password',
    '验证码': 'Captcha',
    '登录': 'Login',
    '注册': 'Register',
    '填写信息': 'Fill form',
    '咨询内容': 'Consultation content',
    '关闭': 'Close',
    '确认': 'Confirm',
    '选择客服': 'Select agent',
    '商户管理': 'Account management',
    '配置管理': 'Configuration',
    '退出': 'Logout',
    '新建商户': 'New account',
    '名称': 'Name',
    '账号': 'Account',
    '邮箱': 'Email',
    '状态': 'Status',
    '操作': 'Operation',
    '正常': 'Normal',
    '禁止登录': 'Login disabled',
    '修改密码': 'Change PWD',
    '名称': 'Name',
    '值': 'Value',
    '新建商户': 'New account',
    '姓名': 'Name',
    '密码': 'Password',
    '手机号': 'Phone',
    '邮箱': 'Email',
    '关闭': 'Close',
    '确认': 'Confirm',
    '在线': 'Online',
    '下线': 'Offline',
    '状态': 'Status',
    '在线': 'Online',
    '离开': 'Away',
    '我的账户': 'My account',
    '退出': 'Logout',
    '个人资料': 'Profile',
    '默认': 'Default',
    '收藏': 'Favorite',
    '隐藏': 'Hide',
    '所有': 'All',
    '置顶': 'Top',
    '收藏': 'Favorite',
    '隐藏': 'Hide',
    '移除标记': 'Remove mark',
    '通知信息': 'Notice',
    '用户昵称': 'User nickname',
    '客服昵称': 'Agent nickname',
    '消息内容': 'Message',
    '发送时间': 'Send time',
    '修改密码': 'Change PWD',
    '姓名': 'Name',
    '昵称': 'Nickname',
    '邮箱': 'Email',
    '修改密码': 'Change PWD',
    '原密码': 'Old password',
    '新密码': 'New password',
    '我的账户': 'My account',
    '用户表单编辑': 'User form edit',
    '部署代码': 'Deploy code',
    '知识库': 'Knowledge base',
    '暂无聊天记录': 'No chat history yet',
    '修改信息': 'Edit',
    '返回': 'Return',
    '密码长度最小为6位': 'Password length must be at least 6 characters',
    '邮箱格式不正确': 'Email format is incorrect',
    '获取验证码': 'Get verification code',
    '请输入邮箱': 'Please input your email',
    '请输入密码': 'Please enter password',
    '请确认密码': 'Please confirm password',
    '请输入验证码': 'Please enter verification code',
    '请等待60秒后再获取验证码': 'Please wait 60 seconds before getting the verification code',
    '请先输入邮箱': 'Please enter your email first',
    '剩余': 'Remaining',
    '秒': 'Second',
    '创建表单项': 'Create form items',
    '常用表单项已经全部添加': 'All common form items have been added',
    '类型': 'Type',
    '填写': 'Input',
    '选填': 'Optional',
    '键': 'Key',
    '选填内容': 'Optional content',
    '格式为': 'The format is',
    '排序': 'Sort',
    '描述': 'Describe',
    '修改表单项目': 'Edit form items',
    '表单不完整': 'Form incomplete',
    '此操作将永久删除该配置项, 是否继续?': 'This operation will permanently delete the configuration item. Do you want to continue?',
    '提示': 'Hint',
    '添加客服': 'Add agent',
    '登录账号': 'Login account',
    '客服名称': 'Agent name',
    '备注': 'Remark',
    '头像': 'Avatar',
    '接线': 'Active',
    '修改密码': 'Change PWD',
    '设置头像': 'Set avatar',
    '添加客服': 'Add agent',
    '账户(必须为3-10位字母数字组合*)': 'Account (must be a 3-10 digit alphanumeric combination*)',
    '备注': 'Remark',
    '修改密码': 'Change PWD',
    '否': 'No',
    '设置头像': 'Set avatar',
}
export default en;
